import NavItem from "react-bootstrap/NavItem";
import { NavLink } from "react-router-dom"

export const CountryNav = () => (
  <nav className="nav nav-tabs">
    <NavItem>
      <NavLink end className="nav-link text-secondary" to="table">테이블</NavLink>
    </NavItem>
    <NavItem>
      <NavLink end className="nav-link text-secondary" to="treemap">트리맵</NavLink>
    </NavItem>
  </nav>
);
